import * as TK from 'components/PDP/Order/LoginOrAddressBook/translations/translation-keys.constants';

export const loginOrAddressBookCommonLocale = {
  [TK.LOGIN_OR_ADDRESS_BOOK_TEXT_FOR_LOGIN]: 'Login to Access Address Book',
  [TK.MARKETPLACE_LOGIN_OR_ADDRESS_BOOK_TEXT_FOR_LOGIN]:
    'Login to Use Address Book',
};
